// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  display: flex;
  flex-direction: row;
}

.login_left_side {
  width: 40%;
  position: relative;
}

.login_right_side {
  width: 60%;
  position: relative;
  background-color: #f3f5f9;
}

.login_header_box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.input_container {
  position: relative;
  /* width: fit-content; */
  margin-top: 10px;
  background-color: #ffffff;
  border-radius: 9px;
}

.input_field {
  width: 600px;
  padding-left: 20px;
  height: 55px;
  background-color: #ffffff;
  color: var(--CARBON-FIBER);
  border: 1px solid #f3f5f9;
  border-radius: 9px;
  font-size: 15px;
  line-height: 21.6px;
}

.end_icon_class {
  position: absolute;
  top: 50%;
  right: 17px;
  transform: translateY(-50%);
  cursor: pointer;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .input_field {
    width: 20rem !important;
  }
  .AuthenticationLeftSide_Vector_Images img {
    width: 32rem !important;
  }
}

@media (min-width: 1024px) and (max-width: 1426px) {
  .input_field {
    width: 25rem !important;
  }
  .AuthenticationLeftSide_Vector_Images img {
    width: 32rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/Login/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".login {\n  display: flex;\n  flex-direction: row;\n}\n\n.login_left_side {\n  width: 40%;\n  position: relative;\n}\n\n.login_right_side {\n  width: 60%;\n  position: relative;\n  background-color: #f3f5f9;\n}\n\n.login_header_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n\n.input_container {\n  position: relative;\n  /* width: fit-content; */\n  margin-top: 10px;\n  background-color: #ffffff;\n  border-radius: 9px;\n}\n\n.input_field {\n  width: 600px;\n  padding-left: 20px;\n  height: 55px;\n  background-color: #ffffff;\n  color: var(--CARBON-FIBER);\n  border: 1px solid #f3f5f9;\n  border-radius: 9px;\n  font-size: 15px;\n  line-height: 21.6px;\n}\n\n.end_icon_class {\n  position: absolute;\n  top: 50%;\n  right: 17px;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .input_field {\n    width: 20rem !important;\n  }\n  .AuthenticationLeftSide_Vector_Images img {\n    width: 32rem !important;\n  }\n}\n\n@media (min-width: 1024px) and (max-width: 1426px) {\n  .input_field {\n    width: 25rem !important;\n  }\n  .AuthenticationLeftSide_Vector_Images img {\n    width: 32rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
